export default __webpack_public_path__ + "static/artifact-026268e3c5037fcecfd7b28f060a8296.png";